import styled from 'styled-components/macro'
import { border, compose, padding, typography, color } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'
import { $truncate } from '../../../../globalStyles'
import { FieldLabel } from '../../ModalForm.styles'
import { ReactComponent as Congrats } from '../../../Icons/Brand/congratulations.svg'

export const SVG_STYLES = {
  width: '100%',
  height: '100%',
  maxWidth: '174px',
  maxHeight: '174px',
  margin: '0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const ModalFormContainer = styled.form`
  padding: 0;
`

export const FrameworkContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 20em);
  grid-gap: 2em;
  justify-content: center;
`

export const ConfirmFrameworkSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 24px;
`

export const ConfirmFrameworkCongrats = styled(Congrats)`
  width: 100%;
  height: 100%;
`

export const ComplianceFrameworkModalTitle = styled.p.attrs({
  fontSize: '24px',
  fontWeight: '600',
})`
  ${typography}
  max-width: 100%;
  ${$truncate}
  // overwrite line-clamp
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`

export const ComplianceFrameworkModalDescription = styled.p.attrs({
  fontSize: '16px',
  color: 'text.med',
  fontWeight: '400',
})`
  ${compose(color, typography)}
`

export const ComplianceFrameworkModalDescriptionWhite = styled(
  ComplianceFrameworkModalDescription,
)`
  color: #fff;
`

export const EnabledFrameworkCard = styled.div.attrs({
  p: 's',
  border: '1px solid',
  borderColor: 'border.primary.light',
  borderRadius: '1em',
})`
  ${compose(padding, border)}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white !important;
  background-color: ${themeGet('colors.fill.neutral.dark')};
  gap: 0.5em;
  text-align: center;
  text-decoration: none;
  width: 20em;
  height: 20em;
  padding-bottom: 2.5em;
  margin: auto;
  &:hover {
    cursor: not-allowed;
  }
`

export const ComplianceFrameworkCardContainer = styled.div.attrs({
  p: 's',
  border: '1px solid',
  borderColor: 'border.primary.light',
  borderRadius: '1em',
})`
  ${compose(padding, border)}
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  text-align: center;
  text-decoration: none;
  width: 20em;
  height: 20em;
  padding-bottom: 2.5em;
  margin: auto;
  &:hover {
    color: unset;
    background-color: ${themeGet('colors.bg.neutral')};
  }
  &:active {
    background-color: ${themeGet('colors.border.neutral.light')};
  }
`

export const StyledComplianceFrameworkInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  p {
    margin: 0;
  }
`

export const StyledFieldLabel = styled(FieldLabel)`
  margin-top: 8px;
`
